import Cookies from 'js-cookie';
import api from 'api';

export const Permissions = {
  CHANGE_PARTNER_ENVIROMENT: 'alterar-parceiro',
  LIST_PARCELAS_BACKOFFICE: 'listar-parcelas-backoffice',
  LIST_RELATORIOS_PARCELAS_BACKOFFICE: 'listar-relatorios-parcelas-backoffice',
  WRITE_OFF_REPORT_INSTALLMENTS_BACKOFFICE: 'baixar-parcelas-relatorio-backoffice',
  EXPORT_INSTALLMENTS_BY_DATE_RANGE_BACKOFFICE: 'exportar-parcelas-por-periodo-backoffice',
  MANUAL_INSTALLMENT_WRITE_OFF: 'baixa-manual-parcela',
};

export const hasPermission = (permission) => {
  const storedPermissions = Cookies.get('splitriskwl-backoffice-permissions');
  if (!storedPermissions) return false;
  const permissionsJson = JSON.parse(storedPermissions);
  return permissionsJson.some(({ feature, hasPermission }) => feature === permission && hasPermission);
};

export const fetchAndSetUserPermissions = async () => {
  const permissions = await api({
    method: 'POST',
    url: `/has-features`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: Cookies.get('splitriskwl-authtoken'),
    },
    data: {
      features: [
        'menu-propostas',
        'menu-apolices',
        'menu-reclamacoes',
        'menu-usuarios',
        'menu-corretores',
        'menu-sinistros',
        'menu-cancelamentos',
        'menu-configuracoes',
        'menu-financeiro',
        'menu-produtos-sva',
        'menu-comissionamento-assessorias',
        'menu-produtos-corporativo',
        'exibir-comissao-cotacao',
        'alterar-equipes-corretor',
        'alterar-equipes-backoffice',
        'alterar-parceiro',
        Permissions.LIST_PARCELAS_BACKOFFICE,
        Permissions.LIST_RELATORIOS_PARCELAS_BACKOFFICE,
        Permissions.WRITE_OFF_REPORT_INSTALLMENTS_BACKOFFICE,
        Permissions.EXPORT_INSTALLMENTS_BY_DATE_RANGE_BACKOFFICE,
        Permissions.MANUAL_INSTALLMENT_WRITE_OFF,
      ],
    },
    json: true,
  });

  Cookies.set('splitriskwl-backoffice-permissions', JSON.stringify(permissions?.data));
};
